import { render, staticRenderFns } from "./Take.vue?vue&type=template&id=5a5e0c3d&scoped=true&"
import script from "./Take.vue?vue&type=script&lang=js&"
export * from "./Take.vue?vue&type=script&lang=js&"
import style0 from "./Take.vue?vue&type=style&index=0&id=5a5e0c3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5e0c3d",
  null
  
)

export default component.exports